/*

Supported languages

 // English - en
  // Spanish - es
  // French - fr
  // Russian - ru
  // Japanese - ja	
  // Indonesian - id
  // Croatian - hr
  // Chinese - zh
  // Swedish - sv
*/

import { capitalizeFirstLetter } from '../capitalizeFirst';

export async function pushNotificationMessage(type, requestData, lang) {
    let title = '', message = '', requestLang;
    let supportedLang = ['en', 'es', 'fr', 'ru', 'ja', 'id', 'hr', 'zh', 'sv', 'ar'];
    requestLang = lang ? lang : 'en';
    requestLang = (supportedLang.indexOf(requestLang) >= 0) ? requestLang : 'en';

    if (type === 'banService') {
        if (requestLang == 'en') {
            title = `One-Moment-Please! Your account has been banned!`;
            message = `One-Moment-Please! Your account has been banned! Please contact our support for any help.`;
        } else if (requestLang == 'es') {
            title = '¡Un momento por favor! ¡Tu cuenta ha sido baneada!';
            message = `¡Un momento por favor! ¡Tu cuenta ha sido baneada! Póngase en contacto con nuestro soporte para cualquier ayuda.`;
        } else if (requestLang == 'fr') {
            title = "Un instant s'il vous plaît! Votre compte a été banni !";
            message = `Un instant s'il vous plaît! Votre compte a été banni ! Veuillez contacter notre support pour toute aide.`;
        } else if (requestLang == 'ru') {
            title = 'Один момент, пожалуйста! Ваш аккаунт заблокирован!';
            message = `Один момент, пожалуйста! Ваш аккаунт заблокирован! Пожалуйста, свяжитесь с нашей службой поддержки для любой помощи.`;
        } else if (requestLang == 'ja') {
            title = 'ちょっと待ってください！あなたのアカウントは禁止されました！';
            message = `ちょっと待ってください！あなたのアカウントは禁止されました！ヘルプが必要な場合は、サポートにお問い合わせください。`;
        } else if (requestLang == 'id') {
            title = 'Tolong tunggu sebentar! Akun Anda telah diblokir!';
            message = `Tolong tunggu sebentar! Akun Anda telah diblokir! Silakan hubungi dukungan kami untuk bantuan apa pun.`;
        } else if (requestLang == 'hr') {
            title = 'Tolong tunggu sebentar! Akun Anda telah diblokir!';
            message = `Trenutak molim! Vaš račun je zabranjen! Molimo kontaktirajte našu podršku za bilo kakvu pomoć.`;
        } else if (requestLang == 'zh') {
            title = '稍等一会儿！您的帐户已被禁止！';
            message = `稍等一会儿！您的帐户已被禁止！如需任何帮助，请联系我们的支持人员。`;
        } else if (requestLang == 'sv') {
            title = 'Ett ögonblick tack! Ditt konto har förbjudits!';
            message = `Ett ögonblick tack! Ditt konto har förbjudits! Kontakta vår support för all hjälp.`;
        } else if (requestLang == 'ar') {
            title = 'لحظة واحدة من فضلك! تم حظر الحساب الخاص بك!';
            message = `لحظة واحدة من فضلك! تم حظر الحساب الخاص بك! يرجى الاتصال بدعمنا للحصول على أي مساعدة.`;
        }
    }

    if (type === 'serviceRequest') {
        if (requestLang == 'en') {
            title = 'Ting-Ting! You got a new job request!';
            message = `You got a new job request for ${requestData['subCategoryList']} at ${requestData['userLocation']}! Are you in?`;
        } else if (requestLang == 'es') {
            title = '¡Ting-Ting! ¡Tienes una nueva solicitud de trabajo!';
            message = `Tienes una nueva solicitud de trabajo para ${requestData['subCategoryList']} en ${requestData['userLocation']}! Está usted en?`;
        } else if (requestLang == 'fr') {
            title = "Ting-Ting ! Vous avez une nouvelle demande d'emploi !";
            message = `Vous avez reçu une nouvelle demande d'emploi pour ${requestData['subCategoryList']} à ${requestData['userLocation']}! Es-tu dans?`;
        } else if (requestLang == 'ru') {
            title = 'Тинг-Тин! Вы получили новый запрос на работу!';
            message = `Вы получили новый запрос на работу для ${requestData['subCategoryList']} в	${requestData['userLocation']}! Вы в?`;
        } else if (requestLang == 'ja') {
            title = 'ティンティン！あなたは新しい仕事のリクエストを受け取りました！';
            message = `あなたはのための新しい仕事の要求を受け取りました ${requestData['subCategoryList']} で ${requestData['userLocation']}! あなたは中にいますか?`;
        } else if (requestLang == 'id') {
            title = 'Ting-Ting! Anda mendapat permintaan pekerjaan baru!';
            message = `Anda mendapat permintaan pekerjaan baru untuk ${requestData['subCategoryList']} pada ${requestData['userLocation']}! Kau di?`;
        } else if (requestLang == 'hr') {
            title = 'Ting-Ting! Dobili ste novi zahtjev za posao!';
            message = `Dobili ste novi zahtjev za posao	${requestData['subCategoryList']} na ${requestData['userLocation']}! Jeste li u?`;
        } else if (requestLang == 'ar') {
            title = 'تينج تينج! لقد حصلت على طلب عمل جديد!';
            message = `لقد حصلت على طلب عمل جديد لـ	${requestData['subCategoryList']} في ${requestData['userLocation']}! هل انت معنا?`;
        }
    }

    if (type === 'cancelledByPartner') {
        if (requestLang == 'en') {
            title = `Oops! ${requestData['partnerDetails']['name']} has canceled the job!`;
            message = `Your job has been canceled by ${requestData['partnerDetails']['name']}. Please find an alternative service provider for your job `;
        } else if (requestLang == 'es') {
            title = `¡Ups! ${requestData['partnerDetails']['name']} ha cancelado el trabajo!`;
            message = `Su trabajo ha sido cancelado por ${requestData['partnerDetails']['name']}.¡Encuentre un proveedor de servicios alternativo para su trabajo!`;
        } else if (requestLang == 'fr') {
            title = `Oops! ${requestData['partnerDetails']['name']} a annulé le travail !`;
            message = `Votre travail a été annulé par ${requestData['partnerDetails']['name']}. Veuillez trouver un autre fournisseur de services pour votre travail ! `;
        } else if (requestLang == 'ru') {
            title = `Ой! ${requestData['partnerDetails']['name']} отменил задание!`;
            message = `Ваша работа была отменена ${requestData['partnerDetails']['name']}. Пожалуйста, найдите альтернативного поставщика услуг для вашей работы! `;
        } else if (requestLang == 'ja') {
            title = `おっとっと！ ${requestData['partnerDetails']['name']} отменил задание!`;
            message = `あなたの仕事は次の理由でキャンセルされました ${requestData['partnerDetails']['name']}。あなたの仕事に適した代替サービスプロバイダーを見つけてください。`;
        } else if (requestLang == 'id') {
            title = `Ups! ${requestData['partnerDetails']['name']} telah membatalkan pekerjaan!`;
            message = `Pekerjaan Anda telah dibatalkan oleh ${requestData['partnerDetails']['name']}. Silakan cari penyedia layanan alternatif untuk pekerjaan Anda! `;
        } else if (requestLang == 'hr') {
            title = `Ups! ${requestData['partnerDetails']['name']} je otkazao posao!`;
            message = `Vaš posao je otkazan od strane ${requestData['partnerDetails']['name']}. Pronađite alternativnog pružatelja usluga za svoj posao! `;
        } else if (requestLang == 'ar') {
            title = `أُووبس! ${requestData['partnerDetails']['name']} ألغى الوظيفة!`;
            message = `تم إلغاء وظيفتك من قبل ${requestData['partnerDetails']['name']}. يرجى البحث عن مزود خدمة بديل لعملك! `;
        }
    }

    if (type === 'cancelledByUser') {
        if (requestLang == 'en') {
            title = `Oops! ${requestData['userDetails']['name']} has canceled the job!`;
            message = `Your job has been canceled by ${requestData['userDetails']['name']}. Find new jobs nearby`;
        } else if (requestLang == 'es') {
            title = `¡UPS! ${requestData['userDetails']['name']} ha cancelado el trabajo!`;
            message = `Su trabajo ha sido cancelado por ${requestData['userDetails']['name']}. Encuentra nuevos trabajos cerca`;
        } else if (requestLang == 'fr') {
            title = `Oups! ${requestData['userDetails']['name']} a annulé le travail !`;
            message = `Votre travail a été annulé par ${requestData['userDetails']['name']}. Trouvez de nouveaux emplois à proximité`;
        } else if (requestLang == 'ru') {
            title = `Ой! ${requestData['userDetails']['name']} отменил задание!`;
            message = `Ваше задание было отменено ${requestData['userDetails']['name']} . Найти новые вакансии поблизости`;
        } else if (requestLang == 'ja') {
            title = `おっと! ${requestData['userDetails']['name']} 仕事をキャンセルしました！`;
            message = `あなたのジョブは ${requestData['userDetails']['name']} によってキャンセルされました。近くの新しい仕事を探す`;
        } else if (requestLang == 'id') {
            title = `Ups.! ${requestData['userDetails']['name']} telah membatalkan pekerjaan!`;
            message = `Pekerjaan Anda telah dibatalkan oleh ${requestData['userDetails']['name']}. Temukan pekerjaan baru di sekitar`;
        } else if (requestLang == 'hr') {
            title = `Oops! ${requestData['userDetails']['name']} je otkazao posao!`;
            message = `Vaš posao je otkazao ${requestData['userDetails']['name']} . Pronađite nove poslove u blizini`;
        } else if (requestLang == 'ar') {
            title = `وجه الفتاة! ${requestData['userDetails']['name']} ألغى الوظيفة!`;
            message = `	تم إلغاء وظيفتك من قبل${requestData['userDetails']['name']}. البحث عن وظائف جديدة في مكان قريب`;
        }
    }

    if (type === 'adminCancelBooking') {
        if (requestLang == 'en') {
            title = `Scheduled service canceled!`;
            message = `Your scheduled service has been canceled by the admin. Please contact the admin for further actions.`;
        } else if (requestLang == 'es') {
            title = `¡Servicio programado cancelado!`;
            message = `El administrador canceló su servicio programado. Comuníquese con el administrador para realizar más acciones.`;
        } else if (requestLang == 'fr') {
            title = `Service programmé annulé !`;
            message = `Votre service programmé a été annulé par l'administrateur. Veuillez contacter l'administrateur pour d'autres actions.`;
        } else if (requestLang == 'ru') {
            title = `Плановое обслуживание отменено!`;
            message = `Ваше запланированное обслуживание было отменено администратором. Для дальнейших действий обращайтесь к администратору.`;
        } else if (requestLang == 'ja') {
            title = `予定されていた運行が中止になりました！`;
            message = `予定されていたサービスは管理者によってキャンセルされました。今後の対応については管理者にお問い合わせください。`;
        } else if (requestLang == 'id') {
            title = `Layanan terjadwal dibatalkan!`;
            message = `Layanan terjadwal Anda telah dibatalkan oleh admin. Silakan hubungi admin untuk tindakan lebih lanjut.`;
        } else if (requestLang == 'hr') {
            title = `Planirani servis otkazan!`;
            message = `Administrator je otkazao vašu zakazanu uslugu. Molimo kontaktirajte administratora za daljnje radnje.`;
        } else if (requestLang == 'ar') {
            title = `تم إلغاء الخدمة المجدولة!`;
            message = `لقد تم إلغاء الخدمة المجدولة من قبل المشرف. يرجى الاتصال بالمسؤول لمزيد من الإجراءات.`;
        }
    }

    if (type === 'partnerRating') {
		if (requestLang == 'en') {
			title = `Great! You got a rating from ${requestData['userName']} for your service on #${requestData['bookingId']}!`;
			message = `You got a rating from ${requestData['userName']} for your service on #${requestData['bookingId']}! `;
		} else if (requestLang == 'es') {
			title = `¡Genial! Tienes una calificación de ${requestData['userName']} Para su servicio en #${requestData['bookingId']}!`;
			message = `Tienes una calificación de ${requestData['userName']} Para su servicio en #${requestData['bookingId']}! `;
		} else if (requestLang == 'fr') {
			title = `Génial! Vous avez une note de ${requestData['userName']} Pour votre service sur #${requestData['bookingId']}!`;
			message = `Vous avez une note de ${requestData['userName']} Pour votre service sur #${requestData['bookingId']}! `;
		} else if (requestLang == 'ru') {
			title = `Здорово! Вы получили рейтинг от ${requestData['userName']} Для вашего обслуживания на #${requestData['bookingId']}!`;
			message = `Вы получили рейтинг от ${requestData['userName']} Для вашего обслуживания на #${requestData['bookingId']}! `;
		} else if (requestLang == 'ja') {
			title = `すごい！あなたはからの評価を得ました ${requestData['userName']} あなたのサービスのために #${requestData['bookingId']}!`;
			message = `すごい！あなたはからの評価を得ました ${requestData['userName']} あなたのサービスのために #${requestData['bookingId']}! `;
		} else if (requestLang == 'id') {
			title = `Besar! Anda mendapat peringkat dari ${requestData['userName']} Untuk layanan Anda di #${requestData['bookingId']}!`;
			message = `Anda mendapat peringkat dari ${requestData['userName']} Untuk layanan Anda di #${requestData['bookingId']}! `;
		} else if (requestLang == 'hr') {
			title = `Sjajno! Imate ocjenu od ${requestData['userName']} za vašu uslugu #${requestData['bookingId']}!`;
			message = `Imate ocjenu od ${requestData['userName']} za vašu uslugu #${requestData['bookingId']}! `;
		} else if (requestLang == 'ar') {
			title = `رائعة! حصلت على تصنيف من ${requestData['userName']} لخدمتكم على #${requestData['bookingId']}!`;
			message = `حصلت على تصنيف من ${requestData['userName']} لخدمتكم على #${requestData['bookingId']}! `;
		}
	}
    
    if (type === 'noProviderFound') {
        if (requestLang == 'en') {
            title = `Apologize! No service provider available at the moment!`;
            message = `Apologize! No service provider available at the moment! Keep try with different requirements!`;
        } else if (requestLang == 'es') {
            title = `¡Pedir disculpas! ¡Ningún proveedor de servicios disponible en este momento!`;
            message = `¡Pedir disculpas! Ningún proveedor de servicios disponible en este momento! Siga intento con diferentes requisitos.!`;
        } else if (requestLang == 'fr') {
            title = `S'excuser! Aucun fournisseur de services disponible pour le moment!`;
            message = `S'excuser! Aucun fournisseur de services disponible pour le moment! Continuez à essayer avec différentes exigences!`;
        } else if (requestLang == 'ru') {
            title = `Извиняться! На данный момент нет поставщика услуг!`;
            message = `Извиняться! Нет поставщика услуг в данный момент! Продолжайте попробовать с разными требованиями!`;
        } else if (requestLang == 'ja') {
            title = `謝罪！現時点で利用可能なサービスプロバイダはありません！`;
            message = `謝罪！瞬間にサービスプロバイダはありません! さまざまな要件で試してください!`;
        } else if (requestLang == 'id') {
            title = `Meminta maaf! Tidak ada penyedia layanan yang tersedia saat ini!`;
            message = `Meminta maaf! Tidak ada penyedia layanan yang tersedia saat ini! Cobalah dengan persyaratan yang berbeda!`;
        } else if (requestLang == 'hr') {
            title = `Ispričavati! Trenutno nema davatelja usluga!`;
            message = `Ispričavati! Trenutno nije dostupan davatelj usluga! Pokušajte s različitim zahtjevima!`;
        } else if (requestLang == 'ar') {
            title = `اعتذر! لا مزود خدمة متاح في الوقت الحالي!`;
            message = `اعتذر! لا يوجد مزود خدمة متاح في الوقت الحالي! استمر في المحاولة بمتطلبات مختلفة!`;
        }
    }

    if (type === 'newMessage') {
		if (requestLang == 'en') {
			title = `Ting! You got a new message from ${requestData['senderName']}`;
		} else if (requestLang == 'es') {
			title = `¡Ting! Tienes un nuevo mensaje de ${requestData['senderName']}`;
		} else if (requestLang == 'fr') {
			title = `Ting! Vous avez reçu un nouveau message de ${requestData['senderName']}`;
		} else if (requestLang == 'ru') {
			title = `Тинг! Вы получили новое сообщение от ${requestData['senderName']}`;
		} else if (requestLang == 'ja') {
			title = `ね！あなたはから新しいメッセージを得ました ${requestData['senderName']}`;
		} else if (requestLang == 'id') {
			title = `! Anda mendapat pesan baru dari ${requestData['senderName']}`;
		} else if (requestLang == 'hr') {
			title = `Ting! Imate novu poruku ${requestData['senderName']}`;
		} else if (requestLang == 'ar') {
			title = `تينغ! حصلت على رسالة جديدة من ${requestData['senderName']}`;
		}

		message = requestData && requestData.message;
	}

    if (type === 'paymentSuccess') {
		if (requestLang == 'en') {
			if (requestData['paymentType'] === 1) {
				title = `Cash-Cash! Receive ${formatAmount(requestData['amount'], requestData['currency'], requestLang)} for work request #${requestData['bookingId']}!`;
				message = `You need to receive ${formatAmount(requestData['amount'], requestData['currency'], requestLang)} for work request #${requestData['bookingId']} from ${requestData['userDetails']['name']}!`;
			} else {
				title = `Earnings! You got a new payment for #${requestData['bookingId']}!`;
				message = `You got ${formatAmount(requestData['amount'], requestData['currency'], requestLang)} payment for #${requestData['bookingId']}! The amount will be transferred to your bank account soon!`;
			}
		} else if (requestLang == 'es') {
			if (requestData['paymentType'] === 1) {
				title = `¡Cash-efectivo! Recibir ${formatAmount(requestData['amount'], requestData['currency'], requestLang)} Para la solicitud de trabajo. #${requestData['bookingId']}!`;
				message = `Necesitas recibir ${formatAmount(requestData['amount'], requestData['currency'], requestLang)} Para la solicitud de trabajo. #${requestData['bookingId']} desde ${requestData['userDetails']['name']}!`;
			} else {
				title = `¡Ganancias! Tienes un nuevo pago por #${requestData['bookingId']}!`;
				message = `Tu tienes ${formatAmount(requestData['amount'], requestData['currency'], requestLang)} Pago por #${requestData['bookingId']}! ¡La cantidad será transferida a su cuenta bancaria pronto!`;
			}
		} else if (requestLang == 'fr') {
			if (requestData['paymentType'] === 1) {
				title = `Cash-Cash! Recevoir ${formatAmount(requestData['amount'], requestData['currency'], requestLang)} Pour la demande de travail #${requestData['bookingId']}!`;
				message = `Vous devez recevoir ${formatAmount(requestData['amount'], requestData['currency'], requestLang)} Pour la demande de travail #${requestData['bookingId']} à partir de ${requestData['userDetails']['name']}!`;
			} else {
				title = `Gains! Vous avez reçu un nouveau paiement pour #${requestData['bookingId']}!`;
				message = `Vous avez ${formatAmount(requestData['amount'], requestData['currency'], requestLang)} paiement pour #${requestData['bookingId']}! Le montant sera transféré sur votre compte bancaire bientôt!`;
			}
		} else if (requestLang == 'ru') {
			if (requestData['paymentType'] === 1) {
				title = `Денежные наличные! Получать ${formatAmount(requestData['amount'], requestData['currency'], requestLang)} для запроса на работу #${requestData['bookingId']}!`;
				message = `Вам нужно получить ${formatAmount(requestData['amount'], requestData['currency'], requestLang)} для запроса на работу #${requestData['bookingId']} от ${requestData['userDetails']['name']}!`;
			} else {
				title = `Доходы! Вы получили новый платеж за #${requestData['bookingId']}!`;
				message = `Ты получил ${formatAmount(requestData['amount'], requestData['currency'], requestLang)} платеж за #${requestData['bookingId']}! Сумма будет передана на ваш банковский счет в ближайшее время!`;
			}
		} else if (requestLang == 'ja') {
			if (requestData['paymentType'] === 1) {
				title = `現金 - 現金！受け取る ${formatAmount(requestData['amount'], requestData['currency'], requestLang)} 仕事依頼のために #${requestData['bookingId']}!`;
				message = `あなたは受け取る必要があります ${formatAmount(requestData['amount'], requestData['currency'], requestLang)} 仕事依頼のために #${requestData['bookingId']} から ${requestData['userDetails']['name']}!`;
			} else {
				title = `earn earn！あなたは新しい支払いを受けました #${requestData['bookingId']}!`;
				message = `あなたが手に入れた ${formatAmount(requestData['amount'], requestData['currency'], requestLang)} 支払い #${requestData['bookingId']}! 金額はすぐにあなたの銀行口座に転送されます！`;
			}
		} else if (requestLang == 'id') {
			if (requestData['paymentType'] === 1) {
				title = `Uang tunai! Menerima ${formatAmount(requestData['amount'], requestData['currency'], requestLang)} untuk permintaan kerja #${requestData['bookingId']}!`;
				message = `Anda perlu menerima ${formatAmount(requestData['amount'], requestData['currency'], requestLang)} untuk permintaan kerja #${requestData['bookingId']} dari ${requestData['userDetails']['name']}!`;
			} else {
				title = `Pendapatan! Anda mendapat pembayaran baru untuk #${requestData['bookingId']}!`;
				message = `Anda dapat ${formatAmount(requestData['amount'], requestData['currency'], requestLang)} pembayaran untuk #${requestData['bookingId']}! Jumlah akan segera ditransfer ke rekening bank Anda!`;
			}
		} else if (requestLang == 'hr') {
			if (requestData['paymentType'] === 1) {
				title = `Cash-Cash! Primati ${formatAmount(requestData['amount'], requestData['currency'], requestLang)} Za zahtjev za radom #${requestData['bookingId']}!`;
				message = `Morate primiti ${formatAmount(requestData['amount'], requestData['currency'], requestLang)} Za zahtjev za radom #${requestData['bookingId']} iz ${requestData['userDetails']['name']}!`;
			} else {
				title = `Zarada! Imate novu uplatu #${requestData['bookingId']}!`;
				message = `Imaš ${formatAmount(requestData['amount'], requestData['currency'], requestLang)} uplata za #${requestData['bookingId']}! Količina će se uskoro prenijeti na vaš bankovni račun!`;
			}
		} else if (requestLang == 'ar') {
			if (requestData['paymentType'] === 1) {
				title = `نقدا نقدا! يستلم ${formatAmount(requestData['amount'], requestData['currency'], requestLang)} لطلب العمل #${requestData['bookingId']}!`;
				message = `تحتاج إلى تلقي ${formatAmount(requestData['amount'], requestData['currency'], requestLang)} لطلب العمل #${requestData['bookingId']} من ${requestData['userDetails']['name']}!`;
			} else {
				title = `الأرباح! حصلت على دفع جديد ل #${requestData['bookingId']}!`;
				message = `أنت حصلت ${formatAmount(requestData['amount'], requestData['currency'], requestLang)} الدفع ل #${requestData['bookingId']}! سيتم نقل المبلغ إلى حسابك المصرفي قريبا!`;
			}
		}
	}

    if (type === 'additionalFeeUserResponse' && requestData) {
		let status = requestData.status;
		if (requestLang == 'en') {
			title = status == "approved" ? `Hurray! ${requestData.userName} has approved your additional work request` : `Oops! ${requestData.userName} has rejected your additional work request!`;
			message = ` ${status == "approved" ? `Your additional work request has been approved by ${requestData.userName}` : `Your additional work request has been rejected by ${requestData.userName}`}`;
		} else if (requestLang == 'es') {
			title = status == "approved" ? `¡Vivo! ${requestData.userName} Su solicitud de trabajo adicional ha sido rechazada por` : `¡Ups! ${requestData.userName} ha rechazado su solicitud de trabajo adicional!`;
			message = ` ${status == "approved" ? ` Su solicitud de trabajo adicional ha sido aprobada por ${requestData.userName}` : `Su solicitud de trabajo adicional ha sido rechazada por ${requestData.userName}`}`;
		} else if (requestLang == 'fr') {
			title = status == "approved" ? `Hourra! ${requestData.userName} Votre demande de travaux supplémentaires a été rejetée par` : `Oops! ${requestData.userName} a rejeté votre demande de travail supplémentaire!`;
			message = `${status == "approved" ? ` Votre demande de travaux supplémentaires a été approuvée par ${requestData.userName}` : `Votre demande de travaux supplémentaires a été rejetée par ${requestData.userName}`}`;
		} else if (requestLang == 'ru') {
			title = status == "approved" ? `Ура! ${requestData.userName} Ваш запрос на дополнительную работу был отклонен` : `Ой! ${requestData.userName} отклонил ваш запрос на дополнительную работу!`;
			message = ` ${status == "approved" ? `  Ваш запрос на дополнительную работу одобрен ${requestData.userName}` : `Ваш запрос на дополнительную работу был отклонен ${requestData.userName}`}`;
		} else if (requestLang == 'ja') {
			title = status == "approved" ? `万歳！${requestData.userName} 追加の作業リクエストはによって拒否されました` : `おっとっと！ ${requestData.userName} あなたの追加作業リクエストを拒否しました!`;
			message = ` ${status == "approved" ? `追加の作業リクエストが承認されました  ${requestData.userName}` : `追加の作業リクエストはによって拒否されました ${requestData.userName}`}`;
		} else if (requestLang == 'id') {
			title = status == "approved" ? `Hore! ${requestData.userName} Permintaan pekerjaan tambahan Anda telah ditolak oleh` : `Ups! ${requestData.userName} telah menolak permintaan pekerjaan tambahan Anda!`;
			message = ` ${status == "approved" ? `  Permintaan pekerjaan tambahan Anda telah disetujui oleh ${requestData.userName}` : `Permintaan pekerjaan tambahan Anda telah ditolak oleh ${requestData.userName}`}`;
		} else if (requestLang == 'hr') {
			title = status == "approved" ? `Hura! ${requestData.userName} Vaš zahtjev za dodatni posao odbio je` : `Ups! ${requestData.userName} je odbio vaš zahtjev za dodatnim radom!`;
			message = ` ${status == "approved" ? ` Vaš zahtjev za dodatni posao odobrio je ${requestData.userName}` : `Vaš zahtjev za dodatni posao odbio je ${requestData.userName}`}`;
		} else if (requestLang == 'ar') {
			title = status == "approved" ? `يا هلا! ${requestData.userName} تم رفض طلب العمل الإضافي الخاص بك من قبل ` : `أُووبس! ${requestData.userName} رفض طلب العمل الإضافي الخاص بك!`;
			message = ` ${status == "approved" ? ` تمت الموافقة على طلب العمل الإضافي الخاص بك من قبل${requestData.userName}` : `تم رفض طلب العمل الإضافي الخاص بك من قبل${requestData.userName}`}`;
		}
	}

    return {
        title,
        message
    };
}

export function formatAmount(amount, currency, locale) {
    let convertCurrency = 'USD';
    if (amount) {
        convertCurrency = currency ? currency : convertCurrency;
        return amount.toLocaleString(locale, { style: 'currency', currency: convertCurrency });
    } else {
        return null;
    }
}

export function formatText(text) {
    let capitalizedText = capitalizeFirstLetter(text);
    return capitalizedText ? capitalizedText.trim() : '';
}